import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ZAR exchange rate (USD to ZAR)
const USD_TO_ZAR = 18.50;

const PaystackCheckout = ({ amount, email, productId, onError, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [zarAmount, setZarAmount] = useState(0);

  useEffect(() => {
    // Calculate ZAR amount (amount is in USD)
    setZarAmount((amount * USD_TO_ZAR).toFixed(2));
  }, [amount]);

  const handlePaystackCheckout = async () => {
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }

    setLoading(true);
    try {
      const callbackUrl = `${window.location.origin}/success?payment_method=paystack`;
      
      const response = await axios.post(`${API}/paystack/initialize`, {
        product_id: productId,
        email: email,
        callback_url: callbackUrl
      });

      const { authorization_url, amount_zar } = response.data;
      
      // Update displayed ZAR amount from backend
      if (amount_zar) {
        setZarAmount(amount_zar.toFixed(2));
      }

      // Redirect to Paystack checkout
      window.location.href = authorization_url;

    } catch (error) {
      console.error('Paystack checkout error:', error);
      toast.error(error.response?.data?.detail || 'Failed to initiate payment. Please try again.');
      if (onError) onError(error);
      setLoading(false);
    }
  };

  return (
    <div className="paystack-checkout-container" data-testid="paystack-checkout">
      <Button
        onClick={handlePaystackCheckout}
        disabled={loading || !email}
        className="w-full h-14 text-lg font-semibold bg-[#0BA4DB] hover:bg-[#0993C7] text-white rounded-xl transition-all duration-200"
        data-testid="paystack-pay-button"
      >
        {loading ? (
          <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            Redirecting to Paystack...
          </>
        ) : (
          <>
            <svg className="mr-2 h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"/>
            </svg>
            Pay with Paystack (R{zarAmount})
          </>
        )}
      </Button>
      <p className="text-center text-sm text-slate-500 mt-3">
        Secure payment powered by Paystack • Accepts all major cards
      </p>
    </div>
  );
};

export default PaystackCheckout;
